export const britechartsCustomEvents = ['customMouseOver', 'customMouseMove', 'customMouseOut'];
